module.exports = __webpack_public_path__ + "img/draw_sharebg.0f7b1381.png";